import { faPlus } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Control, FieldErrors, useFieldArray, UseFormGetValues, UseFormRegister } from "react-hook-form";
import { AddFullButton } from "../components/buttons/addFullButton";
import { ProgramInputs } from "../schemas/inputs";
import { EvaluationFormStage } from "./EvalutionForm/EvaluationFormStage";

interface EvaluationFormProps {
    register: UseFormRegister<ProgramInputs>,
    errors: FieldErrors<ProgramInputs>,
    control: Control<ProgramInputs>;
    getValues: UseFormGetValues<ProgramInputs>;
}

export const EvaluationForm = ({ register, errors, control, getValues }: EvaluationFormProps) => {
    const { fields, append, remove, insert } = useFieldArray({
        control,
        name: "evaluations"
    });

    const duplicateStage = (index: number) => {
        const currentValues = getValues(`evaluations.${index}`);
        insert(index + 1, currentValues);
    };

    const addStage = () => {
        append({
            name: '',
            type: null as any,
            weightPercent: 0 as number,
            startDate: null,
            endDate: null,
            criteria: [],
            sections: []
        });
    };

    useEffect(() => {
        if (fields.length === 0) {
            addStage();
        }
    }, [fields, append]);

    return (
        <span className="d-flex flex-column background-transparent">

            {fields.map((field, index) => (
                <div key={field.id} className="mb-2">
                    <EvaluationFormStage
                        stageIndex={index}
                        totalStages={fields.length}
                        control={control}
                        register={register}
                        errors={errors}
                        onDelete={() => remove(index)}
                        onDuplicate={() => duplicateStage(index)}
                    />
                </div>
            ))}
            <Row className="mt-4">
                <Col>
                    <AddFullButton label="Adicionar etapa" icon={faPlus} handleOnClick={addStage} />
                </Col>
            </Row>
        </span>
    );
};
